<template>
  <ul class="list" v-loading="loading">
    <li v-for="(item, index) in source" :key="index">
      <span>{{ item.type || "公共池" }}</span>
      <span v-for="cell in item.items" :key="cell.state">
        {{ $utils.meta.format("demand-step-client", cell.state) }}
        {{ cell.value }}条
      </span>
    </li>
  </ul>
</template>

<script>
export default {
  props: {
    params: { type: Object },
  },
  data() {
    return {
      loading: false,
      queryParams: { ...this.params },
      source: null,
    };
  },
  mounted() {
    this.loadData();
  },
  methods: {
    loadData() {
      if (this.loading) {
        return;
      }
      this.loading = true;
      this.$apis.job.demand.statis
        .users(this.queryParams)
        .then((res) => {
          this.source = this.$utils.common.DataGroup(res, "name");
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>

<style lang="scss" scoped>
ul.list {
  li {
    line-height: 30px;
    span {
      min-width: 100px;
      display: inline-block;
    }
    span+span{
      margin-left: 10px;
    }
    :first-child {
      font-weight: bold;
    }
  }
  li + li {
    margin-top: 10px;
  }
}
</style>